module.exports = __webpack_public_path__ + "img/software.6d71091d.png";